var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommentUnresolved = function SvgCommentUnresolved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#FF85C0",
    fillOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 4H5.2C4.54 4 4 4.54 4 5.2V12.4C4 13.06 4.54 13.6 5.2 13.6H13.1858C13.451 13.6 13.7054 13.7054 13.8929 13.8929L15.1464 15.1464C15.4614 15.4614 16 15.2383 16 14.7929V5.2C16 4.54 15.46 4 14.8 4Z",
    fill: "#FF85C0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommentUnresolved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "comment-unresolved.25d72837a66ebda0542134d3c9dfbba5.svg";